import Axios from "../../../Config/API";
import { TipoRecorrenciaInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoRecorrencia/TipoRecorrenciaInterface";
import Service from "../../../Service";

//TipoRecorrencia
export async function ListarTipoRecorrenciaService() {
    return Service(
        Axios.get<Array<TipoRecorrenciaInterface>>(
            `/home/tiporecorrencia/listartiporecorrencia`
        )
    );
}

export async function CadastratarTipoRecorrenciaService(
    props: TipoRecorrenciaInterface
) {
    return Service(
        Axios.post(`/home/tiporecorrencia/cadastrartiporecorrencia`, props)
    );
}

export async function EditarTipoRecorrenciaService(
    props: TipoRecorrenciaInterface
) {
    return Service(
        Axios.put(`/home/tiporecorrencia/atualizartiporecorrencia`, props)
    );
}

export async function DeletarTipoRecorrenciaService(IDTipoDocumento: number) {
    return Service(
        Axios.delete(
            `/home/tiporecorrencia/deletartipodocumento?IDTipoDocumento=${IDTipoDocumento}`
        )
    );
}
